module.exports = __webpack_public_path__ + "static/025-0e007a2c7380f99f2ce6a470c76ffc16.jpg";